import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Informations sur l'entreprise */}
          <div className="footer-section">
            <h3>
             <img 
  src="https://i.postimg.cc/t4xTCC3x/Firefly-Remove-Background.png" 
  alt="Logo El Hiba Para" 
  style={{
    height: '50px',
    width: 'auto',
    objectFit: 'contain',
    marginRight: '8px',
    backgroundColor: '#f0f4ff',
    borderRadius: '10px',
    padding: '5px'
  }}
/>
              El Hiba Para
            </h3>
            <p>Votre parapharmacie de proximité sur Ain Aouda.</p>
            
            {/* Réseaux sociaux */}
            <div className="social-media">
              <h4>Suivez-nous</h4>
              <div className="social-links">
                <a 
                  href="https://www.instagram.com/parapharmacie.elhibaainaouda/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link instagram"
                  title="Suivez-nous sur Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a 
                  href="https://web.facebook.com/bparabusiness" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link facebook"
                  title="Aimez-nous sur Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a 
                  href="https://www.tiktok.com/@bparapharmacie" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link tiktok"
                  title="Suivez-nous sur TikTok"
                >
                  <i className="fab fa-tiktok"></i>
                </a>
                <a 
                  href="https://wa.me/212708786202" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link whatsapp"
                  title="Suivez-nous sur Whatsapp"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>                
              </div>
            </div>
          </div>

          {/* Liens rapides */}
          <div className="footer-section">
            <h4>Liens rapides</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">
                  <i className="fas fa-home"></i>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/products">
                  <i className="fas fa-pills"></i>
                  Produits
                </Link>
              </li>
              <li>
                <Link to="/#contact">
                  <i className="fas fa-envelope"></i>
                  Contactez-nous
                </Link>
              </li>
              <li>
                <Link to="/faq">
                  <i className="fas fa-circle-question"></i>
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog">
                  <i className="fas fa-newspaper"></i>
                  Blog
                </Link>
              </li>
              {/*<li>
                <Link to="/admin/login">
                  <i className="fas fa-user-shield"></i>
                  Admin
                </Link>
              </li>*/}
            </ul>
          </div>

          {/* Coordonnées */}
          <div className="footer-section">
            <h4>Contactez-nous</h4>
            <div className="contact-info1">
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <span>0708786202</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <span>pharmacie.elhiba@gmail.com</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>lot 551 , quartier al wahda Ain el aouda , RabatSalé-Kénitra , maroc</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-clock"></i>
                <span>Lundi-Dimanche : 24h/24</span>
              </div>
            </div>
          </div>

          {/* Newsletter & badges de confiance */}
          <div className="footer-section">
            <div className="trust-badges">
              <div className="badge">
                <i className="fas fa-shield-alt"></i>
                <span>Sécurisé</span>
              </div>
              <div className="badge">
                <i className="fas fa-truck"></i>
                <span>Livraison rapide</span>
              </div>
              <div className="badge">
                <i className="fas fa-certificate"></i>
                <span>Certifié</span>
              </div>
            </div>
            <div className="footer-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3030.737757189633!2d-6.78484312465744!3d33.79478887325514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7177c7cc6848f%3A0x9fa3276bda51384f!2sPharmacie%20El%20Hiba%20ain%20aouda!5e1!3m2!1sen!2sma!4v1790814875632!5m2!1sen!2sma"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Localisation El Hiba Para"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Bas de page */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Parapharmacie El Hiba Ain Aouda. Tous droits réservés.</p>
            <div className="footer-bottom-links">
              <a href="/privacy">Conditions générales de vente</a>
              <a href="/terms">Politique de confidentialité</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;